
import React, { memo } from 'react';
import cx from 'classnames';
import Icon from '../../../Icon';
import { HEADER, BACK_ICON } from '../../styles/formModal';
import Text from '../../../Text';
import '../../styles/_modal-header.scss';











/**
   * A modal header component
   *
   * @return {React.Element}
   */
function ModalHeader(
{
  title,
  subtitle,
  description,
  showBackBtn,
  onBackClick,
  titleProps = {},
  suffix
}) {
  return (
    <div className={cx(HEADER({ showBackBtn }), 'modal__header')}>
      <div>
        {
        showBackBtn ?

        <Icon
          clickable={onBackClick}
          className={BACK_ICON}
          name="returnI"
          onClick={onBackClick}
          size={20}
          color="regent"
          hoverColor="denim" /> :


        null}

      </div>
      <div className="modal__header__text">
        <Text heading3 noMargin {...titleProps}>
          {title}
          {suffix || null}
        </Text>
        {subtitle && <Text noMargin="bottom" placeholder>{subtitle}</Text>}
        {description && <Text noMargin="bottom" className="modal-header-description">{description}</Text>}
      </div>
    </div>);

}

export default memo(ModalHeader);